import type { ComponentProps } from "react";
import { surface } from "./foundation";
export function Field({
  orientation = "vertical",
  className,
  ...props
}: ComponentProps<"div"> & { orientation?: "vertical" | "horizontal" | "responsive" }) {
  return (
    <div
      {...props}
      data-slot="field"
      className={[
        "flex gap-1.5",
        orientation === "horizontal" ? "items-center" : "flex-col",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    />
  );
}
export const FieldContent = surface("div", "field-content", "flex flex-col gap-1");
export const FieldGroup = surface("div", "field-group", "flex flex-col gap-3");
export const FieldLabel = surface(
  "label",
  "field-label",
  "flex items-center gap-2 text-sm font-medium",
);
export const FieldDescription = surface(
  "span",
  "field-description",
  "text-xs font-normal text-muted-foreground",
);
export const FieldSet = surface("fieldset", "field-set", "min-w-0 space-y-3");
export const FieldLegend = surface("legend", "field-legend", "text-sm font-medium");
export const FieldTitle = surface("div", "field-title", "text-sm font-medium");
export const FieldSeparator = surface("div", "field-separator", "border-t");
export function FieldError({
  children,
  errors,
  ...props
}: ComponentProps<"div"> & { errors?: Array<{ message?: string } | undefined> }) {
  const messages = [
    ...new Set(errors?.flatMap((error) => (error?.message ? [error.message] : [])) ?? []),
  ];
  return (
    <div {...props} role="alert" className="text-sm text-destructive">
      {children ?? messages.join(" ")}
    </div>
  );
}
